import { render, staticRenderFns } from "./AnswerPreview.vue?vue&type=template&id=13767496&scoped=true"
import script from "./AnswerPreview.vue?vue&type=script&lang=js"
export * from "./AnswerPreview.vue?vue&type=script&lang=js"
import style0 from "./AnswerPreview.vue?vue&type=style&index=0&id=13767496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13767496",
  null
  
)

export default component.exports